// extracted by mini-css-extract-plugin
export var cancelButton = "_p0-5";
export var content = "_p0-3";
export var createButton = "_p0-6";
export var drawerContainer = "_p0-0";
export var footer = "_p0-2";
export var header = "_p0-1";
export var orderFormColumn = "_p0-4";